import React, { Fragment, useState } from 'react';
import { useStyles } from './selector.style';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

interface SelectorProps {
	itemList?: Array<{ id: number; name: string }> | undefined;
	gestation?: any;
	defaultValue?: string;
	onClickPass?: any;
	childId?: any;
}

const Selector = ({ itemList, gestation, defaultValue, onClickPass, childId }: SelectorProps) => {
	const classes = useStyles();
	const [show, setShow] = useState(false);
	const [currentValue, setCurrentValue] = useState<any>(() => defaultValue);
	const HandleClick = () => {
		setShow(!show);
	};
	const handleClose = (value: string) => {
		setCurrentValue(value);
		onClickPass && onClickPass(value, childId && childId);
		gestation(value);
		setShow(!show);
	};

	return (
		<Fragment>
			<div className={`${classes.root} d-flex flex-column flex-nowrap`}>
				<div>
					<button type="button" className={classes.button}>
						{' '}
						{currentValue || 'Gestation'}
					</button>
					<IconButton onClick={HandleClick} className={classes.iconButton} aria-label="arrow dropdown icon">
						<ArrowDropDownIcon />
					</IconButton>
				</div>
				{show ? (
					<ul className={classes.listItems} style={{ display: show ? 'block' : 'none' }}>
						{itemList?.map(item => (
							<li className={classes.item} onClick={() => handleClose(item.name)} key={item.id}>
								{item.name}
							</li>
						))}
					</ul>
				) : (
					''
				)}
			</div>
		</Fragment>
	);
};

export default Selector;
